// =====================
// SCHEDULE VIEW MODULE
// =====================
import { _scheduleVisible, _scheduleTimer, updateState } from '../admin-globals.js';
import { renderSchedule, updateScheduleProgress } from './schedule-renderer.js';

export function toggleScheduleView() {
  const newState = !_scheduleVisible;
  updateState('_scheduleVisible', newState);
  
  const schedEl = document.getElementById('schedule-view');
  const mainEl = document.getElementById('main-content');
  const btn = document.getElementById('btn-schedule');

  if (newState) {
    mainEl.style.display = 'none';
    schedEl.style.display = 'flex';
    btn.style.borderColor = 'rgba(0,255,255,0.6)';
    btn.style.color = 'var(--neon-cyan)';
    renderSchedule();
    const timer = setInterval(updateScheduleProgress, 5000);
    updateState('_scheduleTimer', timer);
  } else {
    mainEl.style.display = '';
    schedEl.style.display = 'none';
    btn.style.borderColor = '';
    btn.style.color = '';
    if (_scheduleTimer) clearInterval(_scheduleTimer);
    updateState('_scheduleTimer', null);
  }
}
